import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import InicioView from "../views/InicioView.vue";
import DashboardsView from "@/views/DashboardsView.vue";
import GestionEntidadesView from "@/views/GestionEntidadesView.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import ClientesView from "@/views/ClientesView.vue";
import AreasView from "@/views/AreasView.vue";
import ProyectosView from "@/views/ProyectosView.vue";
import DashboardsPowerBIView from "@/views/DashboardsPowerBIView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { isPublic: true },
  },
  {
    path: "/inicio",
    name: "inicio",
    component: InicioView,
    meta: { requiresAuth: true },
  },

  //////CLIENTES//////////
  {
    path: "/clients",
    name: "Clientes",
    component: ClientesView,
    meta: {
      requiresAuth: true,
      rolesPermitidos: ["admin", " adminSIST", "lector", "adminTI"],
    },
  },
  {
    path: "/clients/:clienteId/areas",
    name: "Areas",
    component: AreasView,
    props: true,
    meta: {
      requiresAuth: true,
      rolesPermitidos: ["admin", " adminSIST", "lector", "adminTI"],
    },
  },
  {
    path: "/clients/:clienteId/areas/:areaId/proyectos",
    name: "Proyectos",
    component: ProyectosView,
    props: true,
    meta: {
      requiresAuth: true,
      rolesPermitidos: ["admin", " adminSIST", "lector", "adminTI"],
    },
  },

  // Dashboards //
  {
    path: "/dashboards",
    name: "DashboardsView",
    component: DashboardsView,
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboards/:name",
    name: "DashboardsPowerBI",
    component: DashboardsPowerBIView,
    props: true,
  },

  // Gabinetes //
  {
    path: "/gabinetes",
    name: "Gabinetes",
    component: () => import("@/views/GabinetesView.vue"),
    meta: {
      requiresAuth: true,
      rolesPermitidos: ["admin", "adminTI", "adminSIST"],
    },
  },

  // Gestión de acciones sistemas //
  {
    path: "/gestion-entidades",
    name: "GestionEntidades",
    component: GestionEntidadesView,
    meta: {
      requiresAuth: true,
      rolesPermitidos: ["admin", "adminSIST", "adminTI"],
    },
  },

  // Gabinetes catalogo X ID//
  {
    path: "/gabinetes/catalogo/tag/:tag",
    name: "GabinetePorTag",
    component: () => import("@/views/CatalogoView.vue"),
    meta: {
      requiresAuth: false
    },
  },

  // LOGS //
  {
    path: "/logs",
    name: "HistorialLogs",
    component: () => import("@/views/HistorialLogsView.vue"),
    meta: {
      requiresAuth: true,
      rolesPermitidos: ["admin", "adminTI", "adminSIST"],
    },
  },

  //PÁGINA NO ENCONTRADA //
  {
    path: "*",
    name: "NotFound",
    component: NotFoundView,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

// Protección de rutas
router.beforeEach((to, from, next) => {
  let usuario = null;

  // 1) intenta sessionStorage
  const rawSession = sessionStorage.getItem("usuario");
  // 2) fallback a localStorage (para nuevas pestañas)
  const rawLocal = localStorage.getItem("usuario");

  try {
    usuario = JSON.parse(rawSession || rawLocal);
  } catch (e) {
    usuario = null;
  }

  // Ruta protegida y sin sesión → login
  if (to.meta.requiresAuth && !usuario) {
    return next("/");
  }

  // Ruta con restricción de roles
  if (to.meta.rolesPermitidos && usuario) {
    const rolUsuario = (usuario.rol || "").trim().toLowerCase();
    const rolesPermitidos = (to.meta.rolesPermitidos || []).map((r) =>
      String(r || "").trim().toLowerCase()
    );

    if (!rolesPermitidos.includes(rolUsuario)) {
      sessionStorage.setItem(
        "pendingNotify",
        JSON.stringify({
          text: "⛔ Acceso no autorizado para este rol.",
          color: "error",
          icon: "mdi-shield-lock",
        })
      );

      return next("/inicio");
    }
  }

  next();
});

export default router;